import React, { useState, useCallback, useEffect } from "react";
import { Box, Slider, Typography } from "@mui/material";
import Cropper from "react-easy-crop";
import { Area, Point } from "react-easy-crop/types";

interface ImageCropperProps {
  imageSrc: string;
  onCropComplete: (croppedAreaPixels: Area, zoom: number) => void;
  initialZoom?: number;
}

const ImageCropper: React.FC<ImageCropperProps> = ({ imageSrc, onCropComplete, initialZoom }) => {
  const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(initialZoom || 1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);

  useEffect(() => {
    if (initialZoom !== undefined) {
      setZoom(initialZoom);
    }
  }, [initialZoom]);

  const handleCropComplete = useCallback(
    (croppedArea: Area, croppedAreaPixels: Area) => {
      setCroppedAreaPixels(croppedAreaPixels);
      onCropComplete(croppedAreaPixels, zoom);
    },
    [onCropComplete, zoom]
  );

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: 300,
          backgroundColor: "#333",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={1}
          cropShape="round"
          showGrid={false}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
          crossOrigin="anonymous"
        />
      </Box>

      <Box sx={{ px: 2, mt: 3 }}>
        <Typography variant="body2" gutterBottom>
          Zoom
        </Typography>
        <Slider
          value={zoom}
          min={1}
          max={3}
          step={0.1}
          aria-labelledby="zoom-slider"
          onChange={(e, zoom) => setZoom(zoom as number)}
        />
      </Box>
    </Box>
  );
};

export default ImageCropper;
